import BibliographyFreeWordSearch, {
  InputFreeWords,
  defaultInputFreeWords
} from './BibliographyFreeWordSearch.vue'

export { BibliographyFreeWordSearch, InputFreeWords, defaultInputFreeWords }
